import { Modal } from "antd";
import styled, { css } from "styled-components";
import color from "../_style/color";

const basicModal = css`
  .ant-modal-header {
    border-bottom: 0;
    padding: 0;
  }

  .ant-modal-footer {
    border-top: 0;
    padding: 0;
    text-align: unset;
  }

  .ant-modal-footer button + button {
    margin: 0;
  }
`;

const transparentModal = css`
  .ant-modal-content {
    background: unset;
    box-shadow: unset;
  }

  .ant-modal-header {
    background: unset;
    padding: unset;
    border: unset;
  }
`;

const fullscreenModal = css`
  width: unset !important;
  height: 100vh;
  top: unset;
  background-color: ${color.light};
  max-width: unset;
  margin: unset;

  .ant-modal-header {
    border: unset;
    padding: 0;
  }

  .ant-modal-content {
    box-shadow: unset;
    margin: auto;
    width: 100%;
    height: 100%;
  }

  .ant-modal-body {
    height: 90%;
    overflow-y: scroll;
  }
`;

const modalTypes = {
  basic: basicModal,
  transparent: transparentModal,
  fullscreen: fullscreenModal,
};

export default styled(Modal).attrs((props) => ({
  footer: props.footer || false,
  type: props.type || "basic",
  radius: props.radius || "2px",
}))`
  .ant-modal-body {
    padding: 0;
  }

  ${({ type }) => modalTypes[type]}

  .ant-modal-content {
    border-radius: ${({ radius }) => radius};
  }
`;
